import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Field } from 'react-final-form';
import { Select, Row, Col, Datepicker } from '@folio/stripes/components';

const ClearanceEditFields = ({ libraries, disabled }) => {
  const libraryOptions = libraries.map(lib => ({
    value: lib.id,
    label: lib.name,
  }));

  return (
    <>
      <Row>
        <Col xs={4}>
          <Field
            component={Select}
            name="customFields.clearancestatus"
            label={<FormattedMessage id="ui-users.clearance.title" />}
            disabled={disabled}
          >
            <option value="">-</option>
            <option value="opt_1">
              <FormattedMessage id="ui-users.inactive" />
            </option>
            <option value="opt_0">
              <FormattedMessage id="ui-users.clearance.status.cleared" />
            </option>
          </Field>
        </Col>
        <Col xs={4}>
          <Field
            component={Datepicker}
            name="customFields.clearancedate"
            label={<FormattedMessage id="ui-users.clearance.date" />}
            dateFormat="YYYY-MM-DD"
            disabled={disabled}
          />
        </Col>
        <Col xs={4}>
          <Field
            component={Select}
            name="customFields.clearancelibrary"
            label={<FormattedMessage id="ui-users.clearance.library" />}
            disabled={disabled}
          >
            <option value="">
              <FormattedMessage id="ui-users.clearance.library.select" />
            </option>
            {libraryOptions.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Field>
        </Col>
      </Row>
    </>
  );
};

ClearanceEditFields.propTypes = {
  libraries: PropTypes.arrayOf(PropTypes.object),
  disabled: PropTypes.bool,
};

ClearanceEditFields.defaultProps = {
  libraries: [],
  disabled: false,
};

export default ClearanceEditFields;